import React from 'react';
import styled from 'styled-components';
import theme from '../../styles/theme';

const _SelectedTab = styled.div`
  position: absolute;
  height: 70px;
  width: 100%;
  left: 0;
  top: ${props => props.top}px;
  background: ${props => props.color};
  z-index: 9;
  transition: top 0.2s ease-out;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
`

const _Edge = styled.div`
  position: absolute;
  right: 0;
  width: 7px;
  height: 7px;
  background: ${props => props.foreground};

  ${props => props.top ? 'top: -7px' : 'bottom: -7px'};
  &:after {
    content: '';
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background: ${props => props.background};
    position: absolute;
    ${props => props.top ? 'bottom: 0px' : 'top: 0px'};
    right: 0;
  }
`


const SelectedTab = ({
  top,
  colors,
}) => (
  <_SelectedTab top={top} color={colors[1]}>
    <_Edge top foreground={colors[1]} background={colors[0]} />
    <_Edge foreground={colors[1]} background={colors[0]} />
  </_SelectedTab>
)
export default SelectedTab;


// WEBPACK FOOTER //
// ./src/components/menu/selected-tab.js